// Escolha do backend de autenticação a partir do ambiente (fake só em dev — parseEnv rejeita fora).
import type { AppEnv } from '../env';
import { FakeAuthBackend } from './FakeAuthProvider';
import { OidcAuthBackend } from './OidcAuthProvider';
import type { AuthBackend } from './types';

export function createAuthBackend(env: AppEnv, origin: string): AuthBackend {
  if (env.authMode === 'fake') {
    return new FakeAuthBackend({ scenario: env.fakeMeScenario });
  }
  return new OidcAuthBackend({
    authority: env.oidcAuthority,
    clientId: env.oidcClientId,
    origin,
    useEntraPortal: env.environment === 'prod',
  });
}
